export const blueTechTheme = {
    // Primary colors — matched to app paywall palette
    primary: "#2DD4BF",              // teal — app's dominant accent
    primaryDark: "#1BB8A5",          // teal dark
    secondary: "#4C82FF",            // blue — app's secondary accent
    secondaryDark: "#3566E8",        // blue dark
    accentCyan: "#2DD4BF",           // alias for primary teal

    // Gradients
    primaryGradient: "linear-gradient(135deg, #2DD4BF 0%, #4C82FF 100%)",
    logoGradient: "linear-gradient(135deg, #07091A 0%, #2DD4BF 100%)",
    backgroundGradient: "linear-gradient(160deg, #FFFFFF 0%, #F4FFFE 40%, #F0F4FF 100%)",
    featuresGradient: "linear-gradient(160deg, #F4FFFE 0%, #F0F4FF 100%)",
    darkGradient: "linear-gradient(135deg, #07091A 0%, #0D1020 100%)",

    // Background colors
    navBackground: "rgba(255, 255, 255, 0.96)",
    cardBackground: "#FFFFFF",
    surfaceBackground: "#F4FFFE",
    darkBackground: "linear-gradient(135deg, #07091A 0%, #0D1020 100%)",

    // Border colors
    navBorder: "rgba(45, 212, 191, 0.22)",
    cardBorder: "rgba(45, 212, 191, 0.18)",
    inputBorder: "rgba(45, 212, 191, 0.2)",

    // Text colors — app's #07091A becomes web's darkest text
    textPrimary: "#07091A",
    textSecondary: "#6B6B8A",
    textLight: "#B3B3C8",
    textWhite: "#FFFFFF",
    textMuted: "#E0E0F0",

    // Badge / chip colors — teal tint on light background
    badgeBackground: "linear-gradient(135deg, rgba(45, 212, 191, 0.12) 0%, rgba(76, 130, 255, 0.08) 100%)",
    badgeText: "#0FA898",            // darker teal for contrast on light bg

    // Status
    statusSuccess: "#4CAF50",
    statusError: "#FF4C4C",

    // Hover states
    navLinkHover: "rgba(45, 212, 191, 0.07)",
    buttonHover: "rgba(45, 212, 191, 0.08)",

    // Glow / shadow accents for UI depth
    primaryGlow: "rgba(45, 212, 191, 0.28)",
    darkGlow: "rgba(7, 9, 26, 0.3)",

    // Gradient for text on light backgrounds (darker teal→blue for contrast)
    textGradient: "linear-gradient(135deg, #0D9488 0%, #2563EB 100%)",
}